class ProductDetailsAccordion extends HTMLElement {
  constructor() {
    super()

    this.toggle = this.querySelector('.js-accordion-toggle__details')
    this.content = this.querySelector('.js-accordion-content__details')

    if (!this.toggle || !this.content) return

    this.toggle.addEventListener('click', this.onClick.bind(this))
    this.addEventListener('keyup', this.onKeyUp.bind(this))
  }

  onClick() {
    this.isOpen ? this.close() : this.open()
  }

  get isOpen() {
    return this.toggle.getAttribute('aria-expanded') === 'true'
  }

  close() {
    this.toggle.setAttribute('aria-expanded', 'false')
    this.toggle.parentElement.classList.remove('open')
    this.content.hidden = true

    this.content.querySelectorAll('video').forEach((video) => video.pause())
  }

  open() {
    const section = this.closest('.product-details')
    const accordions = section
      ? section.querySelectorAll('product-details-accordion')
      : []

    accordions.forEach((accordion) => {
      if (accordion !== this && typeof accordion.close === 'function') {
        accordion.close()
      }
    })

    this.toggle.setAttribute('aria-expanded', 'true')
    this.toggle.parentElement.classList.add('open')
    this.content.hidden = false
    this.dispatchEvent(new CustomEvent('floyd:media:visible', { bubbles: true }))

    this.content.querySelectorAll('video[autoplay]:not([data-lazy-video])').forEach((video) => {
      video.play().catch(() => {})
    })
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE' && this.isOpen) {
      this.close()
      this.toggle.focus()
    }
  }
}

if (!customElements.get('product-details-accordion')) {
  customElements.define('product-details-accordion', ProductDetailsAccordion)
}
